import { Zap } from 'lucide-react';
import type { PowerCategoryConfig } from '../../utils/powerCategories';

interface PowerCategoryBadgeProps {
  category: PowerCategoryConfig;
  size?: 'sm' | 'md';
  showSubtitle?: boolean;
}

export function PowerCategoryBadge({ category, size = 'sm', showSubtitle = false }: PowerCategoryBadgeProps) {
  const iconSize = size === 'sm' ? 'w-3 h-3' : 'w-4 h-4';
  const textSize = size === 'sm' ? 'text-[10px]' : 'text-xs';
  const padding = size === 'sm' ? 'px-1.5 py-0.5' : 'px-2 py-1';
  const gap = size === 'sm' ? 'gap-0.5' : 'gap-1';

  return (
    <span
      className={`inline-flex items-center ${gap} ${padding} rounded-full border font-semibold ${textSize}`}
      style={{
        backgroundColor: `${category.color}15`,
        borderColor: `${category.color}40`,
        color: category.color,
      }}
    >
      <span className={`inline-flex items-center ${size === 'sm' ? '-space-x-1' : '-space-x-1.5'}`}>
        {Array.from({ length: category.boltCount }).map((_, i) => (
          <Zap key={i} className={iconSize} fill="currentColor" strokeWidth={0} />
        ))}
      </span>
      <span>{category.name}</span>
      {showSubtitle && (
        <span className="opacity-70">({category.subtitle})</span>
      )}
    </span>
  );
}
